/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  GuestInformationSpec,
  ResponseWrapperOfString,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class GuestInformation<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags GuestInformation
   * @name GuestInformationGuestInformation
   * @summary Record a guest information.
   * @request POST:/v1/guest-information
   * @secure
   */
  guestInformationGuestInformation = (
    data: GuestInformationSpec,
    params: RequestParams = {}
  ) =>
    this.http.request<ResponseWrapperOfString, any>({
      path: `/v1/guest-information`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
